'use client'

import 'keen-slider/keen-slider.min.css'

import { CarouselContent } from '@src/components/Carousel/CarouselContent'

import { type CarouselProps } from './CarouselProps'
import { useCarouselHandlers } from './useCarouselHandlers'

/**
 * Carousel component that handles it's own state internally.
 */
export function Carousel(props: CarouselProps) {
  const {
    isLoaded,
    moveOnKeyPress,
    sliderRef,
    instanceRef,
    previousSlide,
    nextSlide,
    currentSlide,
  } = useCarouselHandlers(props)

  return (
    <CarouselContent
      {...props}
      isLoaded={isLoaded}
      moveOnKeyPress={moveOnKeyPress}
      sliderRef={sliderRef}
      instanceRef={instanceRef}
      previousSlide={previousSlide}
      nextSlide={nextSlide}
      currentSlide={currentSlide}
    />
  )
}
